// Any type of activity that can come in through the app. Anything that changes colors or accessories should be here
export enum CommandTypes {
	NO_LIGHT_CHANGE,
	COLOR,
	SCENE,
	THEME,
	REACTION,
	ANIMATION,
	BUILDUPS,
	INTERACTIVE,
}

// Reaction and Animation Types
export enum StudioCommandTypes {
	NO_LIGHT_CHANGE,
	COLOR,
	SCENE,
	THEME,
}

export const ReverseCommandTypes = {
	[CommandTypes.NO_LIGHT_CHANGE]: 'No Light Change',
	[CommandTypes.COLOR]: 'Color',
	[CommandTypes.SCENE]: 'Scene',
	[CommandTypes.THEME]: 'Theme',
	[CommandTypes.REACTION]: 'Reaction',
	[CommandTypes.ANIMATION]: 'Animation',
	[CommandTypes.BUILDUPS]: 'Buildups',
	[CommandTypes.INTERACTIVE]: 'Interactive',
};
